import { ProgramListItem } from 'elements/eventView/atomic/ProgramListItem';
import { PageSection } from 'elements/eventView/layout/PageSection';
import { groupBy, orderBy } from 'lodash';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EventViewProgramPageContent = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { visiblePrograms, programSearchTerm, programDays } = ctxEventView;

    const isInSearchMode = !!programSearchTerm;
    const hasMultipleDays = programDays?.length > 1;
    const substringStartPosition = isInSearchMode && hasMultipleDays ? 0 : 11;

    const groups = groupBy(
        orderBy(visiblePrograms, (e) => e.startDateTime, 'asc'),
        (e) => e.startDateTime.substring(substringStartPosition, 13) + ':00'
    );

    function getGroupTitle(time: string) {
        if (isInSearchMode && hasMultipleDays) {
            const month = time.substring(5, 7);
            const day = time.substring(8, 10);
            const hour = time.substring(11, 13);
            return `${day}.${month} ${hour}:00`;
        }

        return time;
    }

    return (
        <S_EVProgramPageContent className={props.className}>
            {Object.keys(groups).map((time) => {
                const group = groups[time];
                const groupTitle = getGroupTitle(time);

                const sortedGroup = orderBy(group, [
                    'startDateTime',
                    'endDateTime',
                    'normalizedTitle'
                ]);
                return (
                    <PageSection
                        key={sortedGroup[0].startDateTime}
                        titleAlign="center"
                        titleIcon={{ iconPrefix: 'far', iconName: 'clock' }}
                        title={groupTitle}
                    >
                        <S_ProgramList>
                            {sortedGroup.map((item) => {
                                return (
                                    <ProgramListItem
                                        key={item.programId}
                                        program={item}
                                        dateStyle="time"
                                    />
                                );
                            })}
                        </S_ProgramList>
                    </PageSection>
                );
            })}
        </S_EVProgramPageContent>
    );
};

const S_EVProgramPageContent = styled.div``;

const S_ProgramList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;
